var render = function render(){var _vm=this,_c=_vm._self._c;return _c('FastOrdersEditAdmin',{attrs:{"FO":_vm.FO},on:{"saveFastOrders":_vm.saveFastOrders,"createLabelsForFastOrders":_vm.createLabelsForFastOrders}})
}
var staticRenderFns = []

export { render, staticRenderFns }